import { Chip } from '@mui/material';
import React from 'react';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
var CQAHistoryCatalog = function () {
    var columns = [{
            field: 'Srno.',
            headerName: 'Sr. no.',
            headerAlign: 'center',
            minWidth: 100
        }, {
            type: 'string',
            field: 'Date & time',
            headerName: 'Date & time',
            minWidth: 150,
            flex: 1
        }, {
            field: 'User',
            headerName: 'User',
            minWidth: 170,
            flex: 1
        }, {
            field: 'Department',
            headerName: 'Department',
            flex: 1
        }, {
            field: 'Ageingdays',
            headerName: 'Ageing days',
            flex: 1
        }, {
            field: 'Remark',
            headerName: 'Remark',
            flex: 1
        }, {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 180,
            renderCell: function (params) { /*#__PURE__*/ return React.createElement(Chip, {
                label: 'Submitted to ASM',
                size: "small",
                color: "info",
                shape: "rounded"
            }); }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns
        // rows={[{ id: 1 }, { id: 2 }]}
        ,
        dataGridProps: {
            hideFooter: true,
            sx: {
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none'
            }
        }
    }));
};
export default CQAHistoryCatalog;
